import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './page_header.scss';

const PageHeader = ({ className, children, paddingBottom }) => (
  <header
    className={classnames(
      `page-header pb-${paddingBottom} d-flex justify-content-start flex-wrap`,
      className,
    )}
  >
    {children}
  </header>
);

PageHeader.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  paddingBottom: PropTypes.string,
};

PageHeader.defaultProps = {
  paddingBottom: '2',
};

export default PageHeader;
